import { Logo } from "./Logo";

export const Header = ({ onApply }) => (
  <header
    data-testid="site-header"
    className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-[#FBF8F3]/80 border-b border-[#E6DEC3]"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Logo size={34} />
        <div className="leading-tight">
          <p className="font-serif-display text-base sm:text-lg font-semibold text-[#241E1A] tracking-tight">
            Legacy Language Architecture
          </p>
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#8A7E74] hidden sm:block">
            Shellie Davis, M.S., CCC-SLP
          </p>
        </div>
      </div>
      <button
        data-testid="header-apply-button"
        onClick={onApply}
        className="rounded-full bg-[#8C4A32] text-[#FBF8F3] px-5 py-2.5 text-sm font-semibold tracking-wide transition-colors duration-300 hover:bg-[#733B27]"
      >
        Apply Now
      </button>
    </div>
  </header>
);
